<template>
  <PSkeleton
    v-if="loading"
    :height="style.height"
    :width="style.width"
    :shape="shape"
  />
  <div
    v-else
    class="p-d-flex"
  >
    <PAvatar
      :shape="shape"
      :style="style"
      :label="label"
      :icon="icone"
      :class="[classComponent, $attrs.class]"
      :aria-label="alt"
    >
      <div
        v-if="avatar || (!avatar && !label && !icone)"
        id="imagem"
        :style="{
          backgroundImage: `url('${img}')`,
          borderRadius: circle ? '50%' : '',
        }"
        :aria-label="alt"
        role="image"
      />
    </PAvatar>
  </div>
</template>

<script>
import PSkeleton from 'primevue/skeleton';
import PAvatar from 'primevue/avatar';

export default {
  name: 'LGAvatar',
  components: {
    PSkeleton,
    PAvatar,
  },
  props: {
    avatar: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    circle: {
      type: Boolean,
      default: true,
    },
    alt: {
      type: String,
      default: '',
    },
    tamanho: {
      type: Number,
      required: false,
      default: 30,
    },
    icone: {
      type: String,
      default: null,
    },
    uploadIcon: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    borda: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return {
        height: `${this.tamanho}px`,
        width: `${this.tamanho}px`,
        minWidth: `${this.tamanho}px`,
        minHeight: `${this.tamanho}px`,
        fontSize: `${
          this.tamanho > 40 ? Math.ceil(this.tamanho / 2) : 18
        }px !important`,
      };
    },
    iconeClasse() {
      return ['p-avatar-icon', 'p-text-center', this.icone];
    },
    img() {
      if (!this.avatar && !this.label && !this.icone) {
        return `${this.$lg.config.cdn.urlBase}/autoatendimento/${this.$lg.config.cdn.versao}/img/foto_padrao.png`;
      }

      return this.avatar;
    },
    shape() {
      return this.circle ? 'circle' : '';
    },
    classComponent() {
      return {
        'lg-aa-avatar': true,
        'lg-aa-avatar--upload__prime': this.uploadIcon,
        'lg-aa-avatar--com-borda': this.borda,
      };
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
#imagem {
  width: 100%;
  height: 100%;
  background-size: cover !important;
  background-position: center !important;
}
</style>
